var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.123,
    height: 19.011,
    viewBox: "0 0 21.123 19.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "account_tree_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "account_tree_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M93.836,235.011v-3.3H89.769V220.885H87.314v3.432H80V216h7.314v3.3h6.522V216h7.287v8.317H93.836v-3.432H91.354v9.241h2.482v-3.432h7.287v8.317ZM81.584,217.584v0ZM95.42,228.278v0Zm0-10.694v0Zm0,5.149h4.119v-5.149H95.42Zm0,10.694h4.119v-5.149H95.42ZM81.584,222.733H85.73v-5.149H81.584Z",
    transform: "translate(-80 -216)",
    fill: "#1c2d57"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBlack);
export default __webpack_public_path__ + "static/media/map-black.7e01c2c8512e39c0c24719488438578b.svg";
export { ForwardRef as ReactComponent };